export default __webpack_public_path__ + "static/media/whe.bb548654.png";